const ShowDocumentLink = ({document}) => (
  <iframe title={document.label} src={document.link} width="100%" height="100%"/>
);
export default ShowDocumentLink;
